<div
    class="tw-w-full tw-mb-[30px] tw-rounded-[5px] tw-flex tw-flex-col tw-justify-center tw-bg-white tw-bg-opacity-90 tw-px-[10px] md:tw-px-[25px]"
    [ngClass]="
        errorMessage
            ? 'tw-h-auto tw-py-[15px]'
            : 'tw-h-[95px] md:tw-h-[91px] tw-py-[10px] md:tw-py-0'
    "
>
    <!-- Main content row - always centered -->
    <div
        class="tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-gap-[10px] md:tw-gap-0 tw-justify-between"
    >
        <div class="lg:tw-w-[460px] tw-w-[230px] tw-flex tw-flex-col">
            <span
                class="lg:tw-text-[18px] tw-text-[14px] tw-font-semibold tw-text-[#0A0A75] tw-ml-2 md:tw-ml-0"
                >{{"FOOTER.NEWSLETTER_SUBSCRIBE_TEXT" | translate}}</span
            >
            <span *ngIf="errorMessage" class="tw-text-white tw-bg-opacity-90 tw-hidden md:tw-block"
                >.</span
            >
        </div>
        <div
            class="tw-flex tw-flex-col tw-w-[100%] sm:tw-w-[298px] md:tw-w-[462px] xl:tw-w-[712px]"
        >
            <div class="tw-flex tw-flex-row tw-justify-between tw-items-center">
                <input
                    type="email"
                    [placeholder]="'FOOTER.NEWSLETTER_PLACEHOLDER' | translate"
                    [(ngModel)]="email"
                    (input)="onEmailInput()"
                    [disabled]="isSubmitting"
                    (focus)="onEmailFocus()"
                    (input)="onEmailInput()"
                    class="tw-w-full tw-h-[47px] tw-border-[1px] tw-text-black tw-rounded-l-[10px] tw-px-[10px] tw-outline-none focus:tw-border-[#4B6EEC] disabled:tw-bg-gray-100 disabled:tw-cursor-not-allowed tw-text-[12px] md:tw-text-[14px]"
                    [ngClass]="
                        errorMessage
                            ? 'tw-border-red-400'
                            : 'tw-border-[#E0E0E0]'
                    "
                />
                <button
                    (click)="onSubmit()"
                    [disabled]="isSubmitting"
                    class="tw-rounded-r-[10px] tw-h-[47px] tw-w-[150px] tw-text-[12px] lg:tw-text-[14px] tw-text-white tw-transition-colors tw-duration-200 disabled:tw-cursor-not-allowed"
                    [ngClass]="
                        isSubmitting
                            ? 'tw-bg-gray-400'
                            : 'tw-bg-[#4B6EEC] hover:tw-bg-[#3A5BD9]'
                    "
                >
                    <span *ngIf="!isSubmitting">{{
                        "FOOTER.NEWSLETTER_JOIN_NOW" | translate
                    }}</span>
                    <span
                        *ngIf="isSubmitting"
                        class="tw-flex tw-items-center tw-justify-center"
                    >
                        <svg
                            class="tw-animate-spin tw-h-4 tw-w-4 tw-mr-2"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                class="tw-opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                            ></circle>
                            <path
                                class="tw-opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                        </svg>
                        Subscribing...
                    </span>
                </button>
                <button
                    #gaTrigger
                    ga-track="track"
                    [attr.ga-event-id]="gaEventId"
                    [attr.ga-event-category]="gaEventCategory"
                    [attr.ga-event-label]="gaEventLabel"
                    style="display: none"
                ></button>
            </div>

            <!-- Error message display -->
            <div *ngIf="errorMessage" class="tw-mt-[5px]">
                <span class="tw-text-red-400 tw-text-[12px]">{{
                    errorMessage | translate
                }}</span>
            </div>
        </div>
    </div>
</div>
